import React from "react";
import { FiZoomIn } from "react-icons/fi"; // Import zoom icon
import { formatCurrencyUtil, formatNumberUtil, getImageUrl } from "../../../../Utils/localStorageUtils";

const floorPlans = [
  {
    type: "2 BHK Flat",
    size: "1325 Sq-ft",
    price: "₹ 72.9 Lac",
    image:
      "https://img.staticmb.com/mbimages/project/2019/12/19/Floor-Plan-45-Manglams-Aananda-Jaipur-5020643_686_800.jpg",
  },
  {
    type: "3 BHK Flat",
    size: "1865 Sq-ft",
    price: "₹ 1.02 Cr",
    image:
      "https://img.staticmb.com/mbimages/project/2019/12/19/Floor-Plan-45-Manglams-Aananda-Jaipur-5020643_686_800.jpg",
  },
  {
    type: "4 BHK Flat",
    size: "2400 Sq-ft",
    price: "₹ 1.32 Cr",
    image:
      "https://img.staticmb.com/mbimages/project/2019/12/19/Floor-Plan-45-Manglams-Aananda-Jaipur-5020643_686_800.jpg",
  },
];

const FloorPlans = ({ project }) => {


  const floorPricingDetails = project?.floorPricingDetails || [];

  if (floorPricingDetails.length === 0) return null; // Hide if no data

  
  return (
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Floor Plan & Units</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {floorPricingDetails.map((floor, index) => {
           const priceRange =
           floor?.floorPriceMin && floor?.floorPriceMax
             ? `${formatNumberUtil(floor.floorPriceMin)} - ${formatNumberUtil(floor.floorPriceMax)}`
             : formatNumberUtil(floor?.floorPriceMin || floor?.floorPriceMax);
      return   (
          <div
            key={index}
            className="bg-white px-4 py-2 rounded border border-gray-200 flex space-x-4"
          >
            {/* Left Side - Content */}
            <div className="flex-1 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-semibold text-red-600">
                {floor?.bhkType || "N/A"}
                </h3>
                <p className="text-gray-500">
                {floor?.superAreaMin && floor?.superAreaMax
                      ? `${floor.superAreaMin} - ${floor.superAreaMax} ${floor?.superAreaUnit || ""}`
                      : `${floor?.superAreaMin || floor?.superAreaMax || "N/A"} ${floor?.superAreaUnit || ""}`}
                </p>
              </div>
              <p className="text-gray-800 text-[16px]">
                Sale: <span className="font-semibold">
                  {priceRange}
                </span>
              </p>
            </div>

            {/* Right Side - Image with Zoom Icon */}
            {floor?.floorMap?.length > 0 && (
              <div className="w-[90px] h-[90px] relative">
                <img
                  src={getImageUrl(floor?.floorMap?.[0])}
                  onError={(e)=>e.target.src="https://img.staticmb.com/mbimages/project/2019/12/19/Floor-Plan-45-Manglams-Aananda-Jaipur-5020643_686_800.jpg"}
                  alt="Floor Plan"
                  className="w-full h-full object-cover rounded-lg"
                />
                {/* Zoom Icon */}
                <div className="absolute bottom-0 right-0 bg-gray-800 text-white p-2 rounded cursor-pointer hover:bg-gray-600 transition">
                  <FiZoomIn size={18} />
                </div>
              </div>
            )}
          </div>
        )
      }
      )}
      </div>
    </div >
  );
};

export default FloorPlans;
